module.exports = __webpack_public_path__ + "img/ml.aa8d2880.svg";